<template>
	<button
			type="button"
			@click="toggleOrder(dataSort)"
			class="logsSort"
	>
		<svg-sprite
				:class="{'greenColor': !sortDesc && getSortColor(sortBy, dataSort)}"
				width="10"
				height="6"
				icon-id="sort_up"
		></svg-sprite>
		<svg-sprite
				:class="{'greenColor': sortDesc && getSortColor(sortBy, dataSort)}"
				width="10"
				height="6"
				icon-id="sort_down"
		></svg-sprite>
	</button>
</template>

<script>
export default {
	name: "SortBtn",
	props: {
		dataSort: String,
		sortDesc: Boolean,
		sortBy: String
	},
	methods: {
		toggleOrder(value) {
			this.$emit('updateToggleOrder', value);
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
	}
};
</script>

<style scoped lang="scss">
.logsSort {
	display: inline-flex;
	flex-direction: column;
	margin-right: 10px;
}

.greenColor {
	color: #71CC82;
}
</style>
